/* scroll-reveal.js — reveal .imbola-reveal elements on scroll (with optional stagger).
   Add class "imbola-reveal" to any element; optional data-reveal-delay="0.1" (seconds). */
(function () {
  function reveal(el, io) {
    var delay = parseFloat(el.getAttribute('data-reveal-delay') || '0');
    if (delay) el.style.transitionDelay = delay + 's';
    el.classList.add('is-revealed');
    if (io) io.unobserve(el);
  }

  function init() {
    var els = document.querySelectorAll('.imbola-reveal:not(.is-revealed)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { reveal(el); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal(entry.target, io);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // re-run when the theme editor adds/loads a section
  document.addEventListener('shopify:section:load', init);
})();
